import React, {useEffect, useState} from 'react';
import {withRouter} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {groupBy, isEmpty} from "lodash";
import {ItemRow} from "./ItemRow";
import cn from "classnames";
import Loader from "../../../../components/utils/Loader";
import BackButton from "../../../../components/utils/BackButton";
import {TableHeader} from "./TableHeader";
import ReactTooltip from "react-tooltip";
import {utils, writeFileXLSX} from "xlsx";
import {formatDateTime} from "../../../../utils/formatDateTime";
import {styles} from "../../../../containers/goods/styles";
import { fetchWriteoff } from '../../../../action/writeoff';
import { fetchFilials } from '../../../../action/handbook';
import { loaderRawSelector, rawListSelector } from '../../../../selectors/raw';
import { fromStore } from '../../../../selectors';
import { fetchGoods, fetchRawsList, setActiveModalAction } from '../../../../action';
import { reasonsLoadingSelector, reasonsSelector } from '../../../../selectors/forms';
import { fetchWriteOffFormReasons } from '../../../../action/reasons';
import { parseNumToFixed } from '../../../../utils/common';

const textStyles = {
    display: "block",
    width: "auto",
    height: "38px",
    padding: "0.65rem 1rem",
    fontSize: "1rem",
    fontWeight: "400",
    lineHeight: "1.5",
    color: "#495057",
    backgroundColor: "#fff",
    backgroundClip: "padding-box",
    border: "1px solid #e2e5ec",
    borderRadius: "4px",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    boxShadow: "none",
    outline: "none",
    whiteSpace: "nowrap",
};

const DetailWriteOffForm = ({match}) => {
    const {id} = match.params;
    const dispatch = useDispatch()
    const form = useSelector(state => state.writeoffs.detail);
    const loadingWriteoff = useSelector(state => state.loaders.writeoff);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const raws = useSelector(rawListSelector);
    const goods = useSelector(state => state.good.list);
    const goodsLoading = useSelector(fromStore.loaderGoodsSelector);
    const rawMaterialsLoading = useSelector(loaderRawSelector);
    const reasons = useSelector(reasonsSelector);
    const reasonsLoading  = useSelector(reasonsLoadingSelector);
    const loading = loadingWriteoff || goodsLoading || rawMaterialsLoading || reasonsLoading;

    const [groupedProducts, setGroupedProducts] = useState({groupedRawMaterials: [], groupedSemiManufactures: [], groupedGoods: []});

    useEffect(() => {
            if (isEmpty(points) || points.length < pointsCount) dispatch(fetchFilials(null, true));
            if (isEmpty(raws)) dispatch(fetchRawsList());
            if (isEmpty(goods)) dispatch(fetchGoods());
            if (isEmpty(reasons)) dispatch(fetchWriteOffFormReasons());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const renderName = (item, type) => {
        let categoryText;

        if (type === 'good') {
            categoryText = (item.category && item.category.title) ? item.category.title : null;
        } else {
            categoryText = (item.productscategory && item.productscategory.title) ? item.productscategory.title : null;
        }

        return categoryText ? `${categoryText}: ${item.name || `Наименование продукта id ${item.id} не определено`}` : item.name || `Наименование продукта id ${item.id} не определено`;
    }

    useEffect(() => {
        const loadForm = async () => {
            if (id) {
                let result = null;
                if (form && form.id === parseInt(id, 10)) {
                    result = form;
                } else {
                    result = await dispatch(fetchWriteoff(id));
                }
                if (result) {
                    const rawsWriteoff = (result.products.filter((item) => item.type !== 'good') || []).map((raw) => {
                        const entity = raws.find((item) => item.id === raw.id);
                        if (!entity) return raw;
                        return {...raw, name: renderName(entity, raw.type), category: entity.productscategory, measure: entity.measure }
                    });

                    const goodsWriteoff = (result.products.filter((item) => item.type === 'good') || []).map((good) => {
                        const id = typeof good.id === 'string' ? parseInt(good.id.split('_')[0]) : good.id;
                        const entity = goods.find((item) => item.id === id);
                        if (!entity) return good;
                        return {...good, modifications: entity.modifications, name: renderName(entity, good.type), category: entity.category, measure: 'pc' }
                    });

                    const groupedRawMaterials = groupBy(
                        rawsWriteoff.filter((item) => item.type === 'raw'),
                        (item) =>
                            (item && item.category && item.category.title) ||
                            "Без категории"
                    );
                
                    const groupedSemiManufactures = groupBy(
                        rawsWriteoff.filter((item) => item.type === 'semi'),
                        (item) =>
                            (item && item.category && item.category.title) ||
                            "Без категории"
                    );
                
                    const groupedGoods = groupBy(
                        goodsWriteoff,
                        (item) =>
                            (item && item.category && item.category.title) ||
                            "Без категории"
                    );

                    setGroupedProducts({groupedRawMaterials, groupedSemiManufactures, groupedGoods})
                }
            }
        };
        if (!isEmpty(raws) && !isEmpty(goods)) loadForm();
    }, [dispatch, id, form, setGroupedProducts, raws, goods]);

    if (!form || !form.id || loading) return (
        <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
            <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>
        </div>
    );

    const renderGroupedItems = (groupedItems, isSemiManufacture = false) => {
        return Object.entries(groupedItems).map(([category, items]) => (
            <React.Fragment key={category}>
                <tr
                    className="kt-datatable__row"
                    style={{fontWeight: 'bold'}}
                >
                    <td colSpan="3" className="kt-datatable__cell">{category}</td>
                </tr>
                {items.map((item) => (
                    <ItemRow key={item.id} item={item} style={textStyles} isSemiManufacture={isSemiManufacture}/>
                ))}
            </React.Fragment>
        ));
    };

    const renderPointLabel = (point) => {
        if (!point) return '';
        return `${point.city.name}, ${point.street || 'Улица не указана'} ${point.house || ''}`
    }

    const pointAdress = renderPointLabel(points.find((point) => point.id === form.point.id));

    const onExport = () => {
        const groupedItems = {
            'Сырье': groupedProducts.groupedRawMaterials,
            'Полуфабрикаты': groupedProducts.groupedSemiManufactures,
            'Товары': groupedProducts.groupedGoods,
        };

        const exportData = [];

        exportData.push({
            'Филиал': pointAdress,
            'Дата': form.date ? new Date(form.date).toLocaleDateString() : 'Нет данных',
            'Причина списания': form.reason || 'Нет данных',
        });

        exportData.push({});

        Object.keys(groupedItems).forEach((type) => {
            exportData.push({ 'Категория': type, 'Название': '', 'Количество': '', 'Цена': '', 'Сумма': '' });

            Object.entries(groupedItems[type]).forEach(([category, items]) => {
                exportData.push({ 'Категория': '', 'Название': category, 'Количество': '', 'Цена': '', 'Сумма': '' });

                items.forEach((item) => {
                    const name =
                        item.name ||
                        (item.rawMaterial && item.rawMaterial.name) ||
                        (item.semiManufacture && item.semiManufacture.name) ||
                        (item.good && item.good.name) ||
                        'Нет данных';
                    const quantity = parseNumToFixed(item.quantity, 3) || 0;
                    const price = parseNumToFixed(item.price) || 0;
                    const totalPrice = parseNumToFixed(item.totalPrice) || 0;

                    exportData.push({
                        'Категория': '',
                        'Название': name,
                        'Количество': quantity,
                        'Цена': price,
                        'Сумма': totalPrice,
                    });
                });
            });
        });

        exportData.push({});
        exportData.push({
            'Категория': '',
            'Название': '',
            'Количество': '',
            'Цена': 'Итоговая сумма:',
            'Сумма': parseNumToFixed(form.totalSum) || 0,
        });

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Списание");

        writeFileXLSX(wb, `Списание №${form.id || 'неизвестный'}.xlsx`);
    };

    const openChangeLog = () => dispatch(setActiveModalAction({ field: 'changeLogAccountingModal', value: { id: form.id, changeLog: form.changeLog, created_at: form.created_at, type: 'writeoff' }}));

    if (loading) return <div style={styles.formLoading}><Loader text="Загрузка списания..." /></div>

    const reason = reasons.find((item) => item.id === form.writeoffreason.id) || form.writeoffreason;
    return (
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid" style={{marginTop: 25}}>
            <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo">
                <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                    <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid"
                         style={{padding: 0}}>
                        <div className="kt-portlet kt-portlet--mobile">
                            <div className="kt-portlet__body kt-portlet__body--fit">
                                <div style={{position: 'relative', marginBottom: 0}}
                                     className={cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded')}>
                                    <div className="kt-subheader not-mt kt-grid__item">
                                        <div className="kt-container  kt-container--fluid">
                                            <div className="kt-subheader__main">
                                                <h3 className="kt-subheader__title">Форма списания {form.id}</h3>
                                                <span
                                                    className="kt-subheader__separator kt-subheader__separator--v"></span>
                                                <div className="kt-subheader__group" id="kt_subheader_search">
                                                    <BackButton/>
                                                    <button className="btn btn-dark" onClick={onExport}>Экспорт</button>
                                                    <button className="btn btn-secondary" onClick={openChangeLog}>История изменений</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="kt-subheader not-mt kt-grid__item">
                                        <div className="kt-container kt-container--fluid">
                                            <div className="kt-subheader__main">
                                                <div style={textStyles}>
                                                    <span>{form.date ? formatDateTime(form.date) : ''}</span>
                                                </div>
                                                <div style={{marginLeft: 10, ...textStyles}}>
                                                    <span>{pointAdress}</span>
                                                </div>
                                                <div style={{marginLeft: 10, ...textStyles}}>
                                                    <span>{reason.name || 'Причина не указана'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="kt-subheader not-mt kt-grid__item">
                                        <div className="kt-container kt-container--fluid">
                                            <div className="kt-subheader__main">
                                                <div
                                                    style={{
                                                        maxWidth: '100%',
                                                        wordWrap: 'break-word',
                                                        overflowWrap: 'break-word',
                                                        height: 'auto',
                                                        whiteSpace: 'normal',
                                                        padding: '0.65rem 1rem',
                                                        fontSize: '1rem',
                                                        fontWeight: '400',
                                                        lineHeight: '1.5',
                                                        color: '#495057',
                                                        backgroundColor: '#fff',
                                                        border: '1px solid #e2e5ec',
                                                        borderRadius: '4px',
                                                        boxShadow: 'none',
                                                        outline: 'none',
                                                    }}
                                                >
                                                    <span>{form.note ? form.note : 'Примечание не указано'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {!isEmpty(groupedProducts.groupedRawMaterials) && (
                                        <table className="kt-datatable__table">
                                            <TableHeader title="Сырье" />
                                            <tbody className="kt-datatable__body">
                                            {renderGroupedItems(groupedProducts.groupedRawMaterials)}
                                            </tbody>
                                        </table>
                                    )}

                                    {!isEmpty(groupedProducts.groupedSemiManufactures) && (
                                        <table className="kt-datatable__table">
                                            <TableHeader title="Полуфабрикаты" />
                                            <tbody className="kt-datatable__body">
                                            {renderGroupedItems(groupedProducts.groupedSemiManufactures, true)}
                                            </tbody>
                                        </table>
                                    )}

                                    {!isEmpty(groupedProducts.groupedGoods) && (
                                        <table className="kt-datatable__table">
                                            <TableHeader title="Товары" />
                                            <tbody className="kt-datatable__body">
                                            {renderGroupedItems(groupedProducts.groupedGoods)}
                                            <tr>
                                                <td colSpan={5}>
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        padding: '10px 20px',
                                                        borderTop: '1px solid #e0e0e0',
                                                        alignItems: 'center'
                                                    }}>
                                                        <div style={{fontWeight: 'bold', marginLeft: '10px'}}>
                                                            Общая сумма: {parseNumToFixed(form.totalSum)}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <ReactTooltip effect="solid" type="dark" place="top"/>
                </div>
            </div>
        </div>
    );
};

export default withRouter(DetailWriteOffForm);
